import { ProfileContainer } from '@/modules/Profile';

const Profile = (): JSX.Element => <ProfileContainer />;

export default Profile;
